/**
 * This file is part of the box.co.il project.

 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */

;(function($) {
  // company registration form
  // #user-auth-register-company form

  var registerCompanyForm = $('#user-auth-register-company').find('form');

  // enable validation
  if (registerCompanyForm.length) {
    registerCompanyForm.validatorEnableTooltipValidation(window.validationRules.registerCompanyRules);

    // form submit handler
    registerCompanyForm.on('submit', function(e) {
      e.preventDefault();

      var form = $(this);

      // pre submit
      form.find('[name="primary_phone"]').val(form.concatFormValues(form.getTelFields(), ' '));

      // validate and submit
      if(form.validateForm()) {
        $.localStorage.set('domains_bulk', []);
        form.validateSubmit();
      }

      return false;
    });
  }


  // user registration form
  // #user-auth-register-user form

  // enable validation
  var registerUserForm = $('#user-auth-register-user').find('form');

  // enable validation
  if (registerUserForm.length) {
    registerUserForm.validatorEnableTooltipValidation(window.validationRules.registerUserRules);

    // form submit handler
    registerUserForm.on('submit', function(e) {
      e.preventDefault();

      var form = $(this);

      // prepare before submit

      form.find('[name="primary_phone"]').val(form.concatFormValues(form.getTelFields(), ' '));

      // validate and submit
      if(form.validateForm()) {
        $.localStorage.set('domains_bulk', []);
        form.validateSubmit();
      }

      return false;
    });
  }

  // Unified registration form (#user-auth-register)
  var registerForm = $('#user-auth-register').find('form.js-register-form');

  if (registerForm.length && window.validationRules.registerRules) {
    registerForm.validatorEnableTooltipValidation(window.validationRules.registerRules);

    function setRegisterClientType(type) {
      var isCompany = type === 'company';
      var $companyFields = registerForm.find('.js-register-company-fields');
      var $name = registerForm.find('[name="name"]');
      var $id = registerForm.find('[name="id"]');
      var $invoice = registerForm.find('[name="invoice"]');

      registerForm.find('.js-register-label-private').toggleClass('hidden', isCompany);
      registerForm.find('.js-register-label-company').toggleClass('hidden', !isCompany);
      $companyFields.toggleClass('hidden', !isCompany);

      $id.prop('disabled', !isCompany);
      $invoice.prop('disabled', !isCompany);

      if (!isCompany) {
        $id.val('');
        $invoice.val('');
      }

      if ($name.length) {
        var placeholder = isCompany
          ? $name.attr('data-placeholder-company')
          : $name.attr('data-placeholder-private');
        if (placeholder) {
          $name.attr('placeholder', placeholder);
        }
      }

      if (isCompany) {
        registerForm.validatorChangeFieldRules('name', 'required|english_numeric|words_count_min[2]', {
          words_count_min: false
        });
        registerForm.validatorChangeFieldRules('id', 'required|callback_israeli_company_id|callback_foreign_company_id');
        registerForm.validatorChangeFieldRules('invoice', 'required|english_numeric', { required: false });
      } else {
        registerForm.validatorChangeFieldRules('name', 'required|one_word|two_words|english', {
          required: false
        });
        registerForm.validatorChangeFieldRules('id', 'custom', {'custom': function () { return true; }});
        registerForm.validatorChangeFieldRules('invoice', 'custom', {'custom': function () { return true; }});
      }
    }

    registerForm.find('[name="clientType"]').on('change', function() {
      setRegisterClientType($(this).val());
    });

    setRegisterClientType(registerForm.find('[name="clientType"]:checked').val() || 'private');

    registerForm.on('submit', function(e) {
      e.preventDefault();

      var form = $(this);

      form.find('[name="primary_phone"]').val(form.concatFormValues(form.getTelFields(), ' '));

      if (form.validateForm()) {
        $.localStorage.set('domains_bulk', []);
        form.validateSubmit();
      }

      return false;
    });
  }
  // user reset password 2 form
  // #user-auth-register-company form

  // enable validation
  var resetPasswordForm = $('#user-auth-password-reset2').find('form');

  // enable validation
  resetPasswordForm.validatorEnableTooltipValidation(window.validationRules.resetPasswordRules);

  // form submit handler
  resetPasswordForm.on('submit', function(e) {
    e.preventDefault();

    var form = $(this);

    // validate and submit
    if(form.validateForm()) {
      $.localStorage.set('domains_bulk', []);
      form.validateSubmit();
    }

    return false;
  });

  // domain purchase
  // domain owner info
  // enable validation

  // enable validation
  var domainPurchaseForm = $('#domain-purchase-form');

  var errorHandler = function (errors) {
    // if one of tel1, tel2, tel3 or tel4 is empty => show one message
    var phoneFields = ['ownerTel3', 'ownerTel4', 'ownerTel1', 'adminTel3', 'adminTel4', 'adminTel1'];
    var telRequired = false;

    $.each(errors, function(name, data) {
      if(phoneFields.indexOf(name) > -1 && 'required' == data.rule) {
        telRequired = true;

        return false;
      }
    });

    if(telRequired) {
      for (var key in errors) {
        if (errors.hasOwnProperty(key) && phoneFields.indexOf(key) > -1) {
          delete errors[key];
        }
      }

      errors['phone'] = {
        'label': '<span class="error-field">{0}</span>'.format($.translate('Primary Phone')),
        'error': $.translate('Primary phone is required')
      }
    }

    return errors;
  };

  // enable validation
  domainPurchaseForm.validatorEnableDefaultValidation(window.validationRules.purchaseDomainRules,
      function(status, errors, groups) {
        if(-1 !== $.inArray('owner', groups)) {
          return $('#ownerModal').find('.modal-base-content');
        }

        if(-1 !== $.inArray('admin', groups)) {
          return $('#adminModal').find('.modal-base-content');
        }

        if(-1 !== $.inArray('default', groups)) {
          return $('#creditDetails').find('.modal-base-content');
        }

        return $('#domain-purchase-form');
      },
      errorHandler
  );

  // save owner info
  domainPurchaseForm.find('#ownerModal button').on('click', function(e) {
    e.preventDefault();

    var modal = $('#ownerModal'),
        primaryPhone = modal.find('[name="ownerPrimaryPhone"]'),
        faxNumber    = modal.find('[name="ownerFaxNumber"]');

    // copy paste from domain.purchase.js
    if(domainPurchaseForm.validateForm(['owner'])) {
      $('.ownerDetails .error').hide();
      $('.ownerDetails .ok').removeClass('hidden');
      modal.modal('hide');

      // set primary phone and fax
      primaryPhone.val(modal.concatFormValues(modal.getTelFields(), ' '));
      faxNumber.val(modal.concatFormValues(['[name="ownerFax3"]', '[name="ownerFax2"]', '[name="ownerFax1"]'], ' '));
    } else {
      $('.ownerDetails .error').show();
      $('.ownerDetails .ok').addClass('hidden');
    }

    isReadyToBuy();
  });

  // save admin info
  domainPurchaseForm.find('#adminModal button').on('click', function(e) {
    e.preventDefault();

    var modal = $('#adminModal'),
        primaryPhone = modal.find('[name="adminPrimaryPhone"]'),
        faxNumber    = modal.find('[name="adminFaxNumber"]');

    // copy paste from domain.purchase.js
    if(domainPurchaseForm.validateForm(['admin'])) {
      $('.adminDetails .error').hide();
      $('.adminDetails .ok').removeClass('hidden');
      modal.modal('hide');
      // set primary phone and fax number
      primaryPhone.val(modal.concatFormValues(modal.getTelFields(), ' '));
      faxNumber.val(modal.concatFormValues(['[name="adminFax3"]', '[name="adminFax2"]', '[name="adminFax1"]'], ' '));

    } else {
      $('.adminDetails .error').show();
      $('.adminDetails .ok').addClass('hidden');
    }

    isReadyToBuy();
  });

  // admin info auto-filled from an existing contact or not.
  // the fields stay editable and validated: the server always creates a new admin contact from them
  // (the existing contact itself is never changed or reused)
  domainPurchaseForm.find('input[name="contact"]').change(function() {
    var select  = domainPurchaseForm.find('#contacts'),
        exclude = ['adminContacts', 'contact'],
        modal   = $('#adminModal');

    if('contacts' == $(this).val()) {
      select.prop('disabled', false);
      select.trigger('change');
    } else {
      select.prop('disabled', true);
      modal.resetForm(exclude);
    }
  });

  // clear error on default data populated
  $('#ownerModal, #adminModal').on('default-data-populated', function() {
    $(this).validatorClearErrors();
  });

  // change owner validation if client type was changed
  $.purchaseOwnerValidationRules = function(type) {
    if('company' == type) {
      domainPurchaseForm.validatorChangeFieldRules('ownerFullName', 'required|english|words_count_min[2]');
      // messages are registered only for the field's initial rules ('custom'), so pass them here
      domainPurchaseForm.validatorChangeFieldRules('ownerCompanyId', 'required|callback_israeli_company_id|callback_foreign_company_id',
        $.extend({required: $.translate('Company number is required')}, window.validationRules.companyIdMessages));
    } else {
      domainPurchaseForm.validatorChangeFieldRules('ownerFullName', 'required|one_word|two_words|english');
      domainPurchaseForm.validatorChangeFieldRules('ownerCompanyId', 'custom', {'custom': function () {return true;}});
    }
  };

  // listener to change domain purchase owner validation
  $('#ownerModal').find('[type="radio"]').on('change', function() {
    $.purchaseOwnerValidationRules($(this).val());
  });

  // fast hard code to set default validation for adminFullName
  if(0 != domainPurchaseForm.length) {
    var clientType = $('#ownerModal').find('[type="radio"]:checked').trigger('change');

    if(0 != clientType.length) {
      $.purchaseOwnerValidationRules(clientType.val());
    }
  }


  var purchaseSubmitting = false;
  $(document).on('click', '#infoSubmit', function (e) {
    e.preventDefault();
    if (purchaseSubmitting) return;
    var form = $(this).closest('form');
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var emailEl = form.find('#ownerEmail');
    var urlRe = /[a-zA-Z0-9]+\.[a-zA-Z0-9]+|[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)?)/g;
    var creditReg = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
    var stringRe = /^[A-Za-z\s][A-Za-z0-9\s]*$/;
    var fullNameEl = form.find('#ownerFullName');
    var ownerCompanyIdEl = form.find('#ownerCompanyId');
    var priPhoneEl = form.find('#ownerPrimaryPhone');
    var ownerFaxEl = form.find('#ownerFaxNumber');
    var streetEl = form.find('#ownerAddressStreet');
    var cityEl = form.find('#ownerAddressCity');
    var countryEl = form.find('#ownerAddressCountry');
    var zipEl = form.find('#ownerAddressZip');
    var creditCardEl = form.find('#creditNumber');
    var creditYrEl = form.find('#creditExpirationYear');
    var creditMoEl = form.find('#creditExpirationMonth');
    var creditCardCvvEl = form.find('#creditCvv');
    var creditIdEl = form.find('#creditId');
    var approve_termsEl = form.find('#approve_terms');
    var approve_terms = approve_termsEl.is(":checked");
    var date = new Date();
    var domainPeriodEl = form.find('#domainPeriod');
    var creditCard = creditCardEl.val();
    var creditCardYr = creditYrEl.val();
    var creditCardMo = creditMoEl.val();
    var creditCardCvv = creditCardCvvEl.val();
    var creditCardId = creditIdEl.val();
    var paymentMethodEl = form.find('#paymentMethodId');
    var usingSavedPaymentMethod = paymentMethodEl.length > 0 && paymentMethodEl.val();

    var email = emailEl.val();
    var fullName = fullNameEl.val();
    var ownerCompanyId = ownerCompanyIdEl.val();
    var street = streetEl.val();
    var city = cityEl.val();
    var country = countryEl.val();
    var zip = zipEl.val();
    var domainPeriod = parseInt($('[name=domainPeriod]:checked').val());

    var phone1 = form.find('#tel1').val();
    var phone2 = form.find('#tel2').val(validatePerf(form.find('#tel2').val())).val();
    var phone3 = form.find('#tel3').val();

    var fax1 = form.find('#fax1').val();
    var fax2 = form.find('#fax2').val(validatePerf(form.find('#fax2').val())).val();
    var fax3 = form.find('#fax3').val();

    var priPhone = priPhoneEl.val();
    var ns = $('.domain-purchase-ns-name');
    var nsvals = [];

    ns.each(function (i) {
      var val = ns[i].value;
      if (val !== '') {
        nsvals[i] = val;
      }
    });
    var errors = '';
    if (!approve_terms) {
      approve_termsEl.parent().addClass('has-error');
      errors += $.translate('Approve Terms is required') + '\n';

    }
    else {
      approve_termsEl.parent().removeClass('has-error');
    }
    if (domainPeriod < 1 && domainPeriod > 5) {
      domainPeriodEl.parent().addClass('has-error');
      errors += $.translate('Domain Period is invalid') + '\n';
    }
    else {
      domainPeriodEl.parent().removeClass('has-error');
    }
    if (usingSavedPaymentMethod) {
      creditYrEl.parent().removeClass('has-error');
      creditMoEl.parent().removeClass('has-error');
      creditCardCvvEl.parent().removeClass('has-error');
      creditIdEl.parent().removeClass('has-error');
      creditCardEl.parent().removeClass('has-error');
    } else {
    if (isNaN(creditCardYr) || parseInt(creditCardYr) < date.getFullYear()) {
      creditYrEl.parent().addClass('has-error');
      errors += $.translate('Expiry Year is invalid') + '\n';
    }
    else {
      creditYrEl.parent().removeClass('has-error');
    }
    if (isNaN(creditCardMo) || creditCardYr == date.getFullYear() && creditCardMo < date.getMonth()) {
      creditMoEl.parent().addClass('has-error');
      errors += $.translate('Expiry Month is invalid') + '\n';
    }
    else {
      creditMoEl.parent().removeClass('has-error');
    }
    if (isNaN(creditCardCvv) || creditCardCvv.length < 3 || creditCardCvv.length > 4) {
      creditCardCvvEl.parent().addClass('has-error');
      errors += $.translate('cvv is invalid') + '\n';
    }
    else {
      creditCardCvvEl.parent().removeClass('has-error');
    }
    if (isNaN(creditCardId) || creditCardId.length < 9 || creditCardId.length > 9) {
      creditIdEl.parent().addClass('has-error');
      errors += $.translate('id is invalid') + '\n';
    }
    else {
      creditIdEl.parent().removeClass('has-error');
    }
    if (isNaN(creditCard) || creditCard.length < 8 || creditCard.length > 17 || !creditReg.test(creditCard) && creditCard.length > 9 || creditCard[0] === 0) {
      creditCardEl.parent().addClass('has-error');
      errors += $.translate('card is invalid') + '\n';
    }
    else {
      creditCardEl.parent().removeClass('has-error');
    }
    }
    if (!re.test(email) || email === '') {
      emailEl.parent().addClass('has-error');
      errors += $.translate('Email is invalid') + '\n';
    }
    else {
      emailEl.parent().removeClass('has-error');
    }
    if (fullName === '' || !stringRe.test(fullName)) {
      fullNameEl.parent().addClass('has-error');
      errors += $.translate('full name is required') + '\n';
    } else {
      fullNameEl.parent().removeClass('has-error');
    }

    if ($('input[name=clientType]:checked').val() == 'company') {
      if (ownerCompanyId === '' || ownerCompanyId.length == 0) {
        ownerCompanyIdEl.parent().addClass('has-error');
        errors += $.translate('id is invalid') + '\n';
      } else {
        ownerCompanyIdEl.parent().removeClass('has-error');
      }
    }

    if (priPhone === '' || priPhone.length < 8 || phone1 === '' || phone2 === '' || phone3 === '') {
      priPhoneEl.parent().addClass('has-error');
      errors += $.translate('Primary phone is required') + '\n';
    }
    else {
      priPhoneEl.parent().removeClass('has-error');
    }
    if (street === '' || street.length < 2 || !/[0-9]/.test(street)) {
      streetEl.parent().addClass('has-error');
      errors += $.translate('Street is required') + '\n';
    }
    else {
      streetEl.parent().removeClass('has-error');
    }
    if (city === '' || !stringRe.test(city)) {
      cityEl.parent().addClass('has-error');
      errors += $.translate('City is required') + '\n';
    }
    else {
      cityEl.parent().removeClass('has-error');
    }
    if (country === '' || !stringRe.test(country)) {
      countryEl.parent().addClass('has-error');
      errors += $.translate('Country is required') + '\n';
    }
    else {
      countryEl.parent().removeClass('has-error');
    }
    if (zip === '') {
      zipEl.parent().addClass('has-error');
      errors += $.translate('Zip is required') + '\n';
    }
    else {
      zipEl.parent().removeClass('has-error');
    }

    if (nsvals.length > 0) {
      $.each(nsvals, function (i) {
        if (nsvals[i] !== '' || !urlRe.test(nsvals[i])) {
          ns.parent().removeClass('has-error');
        }
        else {
          ns.parent().addClass('has-error');
          errors += $.translate('you must fill at least one correct Name Server') + '\n';
        }
      });
    }
    else {
      errors += $.translate('you must fill at least one Name Server') + '\n';
      ns.parent().addClass('has-error');
    }
    if (errors !== '') {
      $('#info-errors').html(nl2br(errors, true)).removeClass('hidden');
      window.scrollTo(0, 0);
      return false;
    } else {
      purchaseSubmitting = true;
      $('#infoSubmit').button('loading');
      $('#info-errors').addClass('hidden');
      $.post($('#domain_order form').attr('action'), $('#domain_order form').serialize(), function (data) {
        if (data.status === 0) {
            $.showError(nl2br(data.msg, true));

            purchaseSubmitting = false;
            $('#infoSubmit').button('reset');
        }

        if (data.status === 1) {
          $('#main-content').html(data.msg);
          window.location = Storage.getData('app_url') + data.page;
        }

        if (data.status == 2) {
          window.location = window.location;
        }
      }).fail(function () {
        purchaseSubmitting = false;
        $('#infoSubmit').button('reset');
        $.showError($.translate('unkown error occured'));
      });
    }
  });

})(jQuery);
